// extracted by mini-css-extract-plugin
module.exports = {"orderIdFilterInfoIcon":"OrderTable_orderIdFilterInfoIcon__1sRsM","orderIdFilterInput":"OrderTable_orderIdFilterInput__2kidh"};